<main class="content d-flex flex-column vi-gap-24">
  <headline-text [headline]="'APPOI.PROPOSAL_DECLINED_TIME_SLOTS.HEADLINE' | translate"
                 [text]="'APPOI.PROPOSAL_DECLINED_TIME_SLOTS.DESCRIPTION' | translate"
  ></headline-text>

  <mat-card>
    <mat-card-content>
      <h2>{{ 'APPOI.PROPOSAL_DECLINED_TIME_SLOTS.ALTERNATIVE_DATES' | translate }}</h2>
      <form (ngSubmit)="send()"
            [gtmEventData]="{ 'decision': showFeedbackForm ? 'NO_DATE_CHOSEN' : 'DATE_CHOSEN' }"
            [gtmEventName]="'alternative_date_selection'">
        <fieldset>
          <legend class="d-none">{{ 'APPOI.PROPOSAL_DECLINED_TIME_SLOTS.DESCRIPTION' | translate }}</legend>
          <div class="selection-list">
            <div class="selection-list-header selection-list-row">
              <div class="cell-radio"></div>
              <div class="cell-date-time">
                <div class="cell-date">{{ 'APPOI.LABEL_DATE' | translate }}</div>
                <div class="cell-time">{{ 'APPOI.LABEL_ARRIVAL_TECHNICIAN' | translate }}</div>
              </div>
            </div>

            <mat-radio-group
              [ngModel]="selectedTimeSlot"
              (ngModelChange)="onTimeSlotSelect($event)"
              name="selectedTimeSlot"
              [attr.aria-label]="'APPOI.PROPOSAL_DECLINED_TIME_SLOTS.ALTERNATIVE_DATES' | translate">
              <mat-radio-button *ngFor="let item of this.timeSlots.items | slice: 0:itemsToShow"
                                [value]="item"
                                [aria-label]="getAriaLabelForTimeSlot(item)"
                                class="vi-radio selection-list-row">
                <div class="cell-date-time">
                  <div class="cell-date">{{ item.displayBegin | date : 'mediumDate' : appointment.timezone : locale }}
                  </div>
                  <div *ngIf="timeSlots.displayType === 'FROM'"
                       [attr.data-label]="'APPOI.LABEL_ARRIVAL_TECHNICIAN' | translate"
                       [translateParams]="{
                  beginTimeFrom: item.displayBegin | date : 'shortTime' : appointment.timezone : locale
                 }"
                       [translate]="'APPOI.LABEL_ARRIVAL_TECHNICIAN.DISPLAY_TYPE_FROM'"
                       class="cell-time"
                  ></div>
                  <div *ngIf="timeSlots.displayType === 'FROM_TILL' || timeSlots.displayType === 'FIXED_TIME'"
                       [attr.data-label]="'APPOI.LABEL_ARRIVAL_TECHNICIAN' | translate"
                       [translateParams]="{
                  beginTimeFrom: item.displayBegin | date : 'shortTime' : appointment.timezone : locale,
                  beginTimeEnd: item.displayEnd | date : 'shortTime' : appointment.timezone : locale,
                 }"
                       [translate]="'APPOI.LABEL_ARRIVAL_TECHNICIAN.DISPLAY_TYPE_FROM_TILL'"
                       class="cell-time"
                  ></div>
                </div>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </fieldset>

        <div *ngIf="itemsToShow < timeSlots.items.length" class="load-more">
          <button type="button"
                  (click)="loadMore()"
                  [gtmEventName]="'load_more_appointments'"
                  mat-flat-button
          >{{ 'APPOI.BUTTON.LOAD_MORE' | translate }}
            <mat-icon>expand_more</mat-icon>
          </button>
        </div>

        <div class="selection-list no-header option-no">
          <mat-radio-group
            [ngModel]="selectedTimeSlot"
            (ngModelChange)="onTimeSlotSelect(null)"
            name="selectedTimeSlotNoOption"
            [attr.aria-label]="'APPOI.PROPOSAL_DECLINED.OPTION_NO_TIME_SLOT_FITS' | translate">
            <mat-radio-button [value]="null"
                              class="vi-radio selection-list-row">
              <span class="cell-no-option semiBold">{{ 'APPOI.PROPOSAL_DECLINED.OPTION_NO_TIME_SLOT_FITS' | translate }}</span>
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div *ngIf="showFeedbackForm" class="feedbackForm">
          <feedback-form-declined
            (formControlOutput)="handleFeedbackForm($event)"
            (outputData)="receiveOutput($event)"
            (sendForm)="sendData($event)"
          ></feedback-form-declined>
        </div>

        <div *ngIf="!showFeedbackForm" class="d-flex actions">
          <button type="submit"
                  [disabled]="disableSendButton()"
                  class="vi-button"
                  color="primary"
                  mat-flat-button>{{ 'APPOI.BUTTON.SEND' | translate }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</main>
